// extracted by mini-css-extract-plugin
export default {"langMenu":"Language_langMenu__1UhaL","langBtn":"Language_langBtn__UmydL"};